(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["laam-card-styles"] && !Shopify.designMode) return;
  try {
    function laamWishlistInit() {
    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem('laam_wishlist') || '[]');
    } catch (e) {
      stored = [];
    }
    document.querySelectorAll('.laam-wishlist-btn').forEach(function (btn) {
      if (stored.indexOf(btn.dataset.productId) > -1) {
        btn.classList.add('is-active');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.laam-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.dataset.productId;
    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem('laam_wishlist') || '[]');
    } catch (err) {
      stored = [];
    }
    var idx = stored.indexOf(id);
    if (idx > -1) {
      stored.splice(idx, 1);
      btn.classList.remove('is-active');
    } else {
      stored.push(id);
      btn.classList.add('is-active');
    }
    localStorage.setItem('laam_wishlist', JSON.stringify(stored));
  });

  document.addEventListener('DOMContentLoaded', laamWishlistInit);
  document.addEventListener('shopify:section:load', laamWishlistInit);
  laamWishlistInit();
  } catch(e) { console.error(e); }
})();

})();
